import type { LearningActivityStatus } from '@openclassrooms/sdk-web';

export const STATUS_PROMOTION = 'promotion';

export const CHAPTER_STATUSES = [STATUS_PROMOTION, 'not started', 'in progress', 'passed'] as const;

export const QUIZ_STATUSES = [
  'not started',
  'in progress',
  'retry',
  'failed',
  'passed',
  STATUS_PROMOTION,
] as LearningActivityStatus[];

export const QUIZ_COMPLETED_STATUSES = ['retry', 'failed', 'passed'] as const;
